export class QueryModel {
    constructor(
        public reservationCode: string
    ) { }
}